import {Component, OnInit, ViewChild} from '@angular/core';
import {filter} from 'rxjs/operators';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import { HttpClient } from "@angular/common/http";
import {SocoHttpService} from '@app/soco/http';
import {
  ConstantsService, SessionService, CompaniesEnum, LookupsService,
  LimitlessUiService, LoggerService, AccountService, User, EntityLookup
} from '@app/base/core';

import {BuilderHeaderComponent} from './header/builder.header.component';

@Component({
  selector: 'builder-shell',
  templateUrl: './builder-shell.component.html',
  styleUrls: ['./builder-shell.component.css']
})
export class BuilderShellComponent implements OnInit {

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private logger: LoggerService,
      private lookupSvc: LookupsService,
      private limitlessSvc: LimitlessUiService,
      private constantsSvc: ConstantsService,
      private sessionSvc: SessionService,
      private accountService: AccountService,
      private ngHttp: HttpClient,
      private socoHttp: SocoHttpService) {

    // Mark App Shell Bootstrapped -> Browser Console
    this.logger.log(`%c » Builder Shell Bootstrapped            `, 'background: #3c3c3c; color: white; font-size: 13px;');

    // Load common lookups
    // if (!this.lookupSvc.commonLookupsLoaded) {
    //   this.lookupSvc.loadCommonLookups();
    //   const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(isloaded => {
    //     this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
    //     if (isloaded) {
    //       subscribe.unsubscribe();
    //       this.socoHttp.hidePleaseWait('ContainerAwaiter');
    //     }
    //   });
    // }
  }

  @ViewChild(BuilderHeaderComponent, {static: false}) headerComponent: BuilderHeaderComponent;

  ngOnInit() {
    if (!this.lookupSvc.commonLookupsLoaded) {
      this.lookupSvc.loadCommonLookups();
    }

    // Subscribe and handle route\router events
    this.subscribeRouteEvents();

    this.sessionSvc.waitFlag.subscribe(result => {
      if (result) {
        this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
      } else {
        this.socoHttp.hidePleaseWait('ContainerAwaiter');
      }
    });
  }

  private subscribeRouteEvents() {
    // Subscribe to route data, injected by Account Resolver...
    this.route.data.subscribe(({accountInfo}) => { // Should check for errors here
      if (accountInfo && accountInfo.length === 3) {
        this.accountService.account.user.company = accountInfo[1].data.company;
        this.accountService.account.user.givenName = accountInfo[1].data.givenName;
        this.accountService.account.user.username = accountInfo[1].data.username;
        this.accountService.account.user.email = accountInfo[1].data.email;
        this.accountService.account.settings = accountInfo[2] ? accountInfo[2].data : null;
      } else {
        const user = new User;
        user.givenName = 'Anonymous';
        this.accountService.account.user = user;
      }
    }, err => {
      console.log('Error occured while fetching API Info.' + err);
    });

    // Detect and resolve parameterized LDC
    this.route.params.subscribe(params => {
      const defaultLdc = this.constantsSvc.defaultLdc;
      if (params['ldc']) { // If we received ldc, then try to match it with a known LDC enum
        const paramLdc = String(params['ldc']).trim().toUpperCase();
        // Ensure that incoming query param is matching one of known LDCs in Companies enum before stroing it.
        if ((Object.keys(CompaniesEnum).map(e => CompaniesEnum[e].toUpperCase()).indexOf(paramLdc) >= 0)) {
          if (paramLdc === defaultLdc.toUpperCase()) {
            this.navigateToLanding();
          } else {
            this.sessionSvc.paramLdc = params['ldc'].trim().toUpperCase();
            // TODO: DSS: created an observable to support failing applicant bcalookup calls (applicant.component.ts) - BT 3/5/24
            this.sessionSvc.GetActiveLdc(this.lookupSvc.companies[this.sessionSvc.paramLdc]);

          }
        } else {
          this.navigateToLanding();
        } // Value passed in :ldc is unknown LDC, Route to company and pass default LDC as :ldc
      } else {
        this.navigateToLanding();
      } // No LDC passed in route, route to company and pass default LDC as :ldc
    });

    // Listen for route changes and update paramLDC\activeLDC accordingly.
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
      // User navigating to company\landing page && paramLdc is not default 'SC',
      // user coming from app pages to company\landing, then show default company 'SC'.
      if (event.url.indexOf('company') > -1 && this.sessionSvc.paramLdc !== this.constantsSvc.defaultLdc) {
        this.sessionSvc.paramLdc = this.constantsSvc.defaultLdc;
      }

      // Update activeLdc based on paramLdc
      this.sessionSvc.activeLdc = this.lookupSvc.companies[this.sessionSvc.paramLdc];

      // This gets executed when user navigate from on component to the other;
      this.limitlessSvc.initLimitless();
    });


  }

  private navigateToLanding() {
    this.router.navigate([this.constantsSvc.defaultLdc.toLowerCase(), 'company']);
  }
}
